import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from "@angular/router";
import { Biggen } from '../directives/biggen';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-manuscripts',
  imports: [Biggen, RouterLink, Link],
  templateUrl: './manuscripts.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './manuscripts.scss',
})
export class Manuscripts {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Manuscripts`);
    this.dynamicTitle.description(`The manuscripts of the New Testament, are not original documents but rather copies that were made centuries after the supposed lifetime of Jesus.`);
  }
}
